import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Item } from '@api/catalog/items/medias/items.models';
import { OrderPartialGiftTicketItem } from '@api/order/order.models';
import { OrderService } from '@api/order/order.service';
import { BrowserOnly } from '@core/data-providers/platform/platform.decorators';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';

@Injectable()
export class GiftTicketDownloadService {
    constructor(
        private readonly store: Store,
        private readonly orderService: OrderService,
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    public download(
        orderId: number,
        items: Item[],
        selectedMap: Record<Item['id'], boolean>,
        quantityMap: Record<Item['id'], number>
    ): Observable<void> {
        const selectedItems = this.getItemsToDownload(items, selectedMap);
        const orderItems: OrderPartialGiftTicketItem[] = this.parseItems(selectedItems, quantityMap);
        return this.store.select(getStoreAndLanguage).pipe(
            switchMap(({ storeId }) =>
                this.orderService.orderPartialGiftTicket(storeId, orderId, { orderItems }).pipe(
                    map(data => { this.downloadPDF(data); })
                ))
        );
    }

    private getItemsToDownload(items: Item[], selected: Record<Item['id'], boolean>): Item[] {
        return items.filter((item) => selected[item.id]);
    }

    private parseItems(selectedItems: Item[], quantity: Record<Item['id'], number>): OrderPartialGiftTicketItem[] {
        return selectedItems.map((item) => ({
            orderItemId: item.id,
            quantity: quantity[item.id] || item.quantity,
        }));
    }

    @BrowserOnly<GiftTicketDownloadService, undefined>(undefined)
    private downloadPDF(data: ArrayBuffer): void {
        const blob = new Blob([data], { type: 'application/pdf' });
        const a = this.window.document.createElement('a');
        const url = this.window.URL.createObjectURL(blob);
        a.style.display = 'none';
        this.window.document.body.appendChild(a);
        a.href = url;
        a.download = 'MassimoDutti.pdf';
        a.click();
        a.remove();
    }
}
